<template>
  <div class="amount-input-container">
    <div class="input-group">
      <label for="inputAmount">金额</label>
      <!-- 修改部分：将下拉框替换为输入框 -->
      <template v-if="gameid === '2'  || gameid === '3'">
        <input 
          type="number" 
          id="inputAmount" 
          v-model="inputAmount" 
          :disabled="isGameIdOne"
          placeholder="请输入50-999范围内的金额"
          @input="validateInputAmount"
          min="1" 
          step="1"
        >
      </template>
      <template v-else>
        <input 
          type="number" 
          id="inputAmount" 
          v-model="inputAmount" 
          :disabled="isGameIdTwo || isGameIdOne"
          placeholder="请输入50-999范围内的金额"
          @input="validateInputAmount"
          min="1" 
          step="1"
        >
      </template>
    </div>

    <!-- 新增错误提示 -->
    <div v-if="errorMessage" class="error-message">{{ errorMessage }}</div>
    <!-- 修改按钮的 disabled 属性，并绑定点击事件 -->
    <button 
      @click="submitAmount" 
      class="submit-button"
      :disabled="isSubmitting"
    >
      {{ isSubmitting ? '提交中...' : '确定' }}
    </button>
  </div>
</template>

<script>
import axios from 'axios';
import md5 from 'js-md5';

export default {
  data() {
    return {
      inputAmount: '',
      isGameIdTwo: false,
      isGameIdOne: false,
      gameid: null,
      id: null,
      urlAmount: null,
      payChannelId:null,
      buyerName: '空', 
      // 新增错误提示信息变量
      errorMessage: '',
      // 新增提交状态
      isSubmitting: false
    };
  },
  async mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    this.gameid = urlParams.get('gameid');
    this.id = urlParams.get('id');
    this.urlAmount = urlParams.get('amount');
    this.payChannelId = urlParams.get('paychannelid');

    // 修改部分：将判断条件从 gameid === '2' 改为 gameid 等于 '2' 或 '3'
    if (this.gameid === '2' || this.gameid === '3') {
      this.isGameIdTwo = true;
      if (this.urlAmount && parseInt(this.urlAmount) > 0) {
        this.inputAmount = this.urlAmount;
        this.isGameIdOne = true; 
      } 
    } else if (this.gameid === '1' && this.urlAmount) {
      this.inputAmount = this.urlAmount;
      this.isGameIdOne = true;
    }
  },
  methods: {
    validateInputAmount() {
      // 过滤掉小数点
      this.inputAmount = this.inputAmount.replace('.', ''); 
      if (this.inputAmount === '') {
        // 若输入为空，不做处理，允许用户继续输入
        return;
      }
      let value = parseInt(this.inputAmount);
      if (isNaN(value) || value < 1) {
        this.inputAmount = '1';
      } else if (value > 999) {
        this.inputAmount = '999';
      }
    },
    async submitAmount() {
      // 如果正在提交，直接返回
      if (this.isSubmitting) return;
      // 设置为正在提交状态
      this.isSubmitting = true;
      // 清空之前的错误信息
      this.errorMessage = '';

  
      // 验证金额必须为大于 0 小于 1000 的整数
      const amount = parseInt(this.inputAmount);
      if (isNaN(amount) || amount <= 0 || amount >= 1000) {
        this.errorMessage = '金额必须为大于 0 小于 1000 的整数';
        // 恢复可点击状态
        this.isSubmitting = false;
        return;
      }
  
      try {
        const key = process.env.VUE_APP_API_KEY;
        const timestamp = new Date().getTime();
        const token = md5(timestamp + key);
        const response = await axios.post(`${window.location.origin}/api2/Pay3`, {
          amount: this.inputAmount,
          id: this.id,
          token: token,
          gameid: this.gameid,
          payChannelId: this.payChannelId,
          timestamp: timestamp,
          buyerName: this.buyerName, 
        });
        console.log('创建订单响应:', response.data);
        const payUrl = response.data.data.payurl;
        if (payUrl) {
          window.location.href = payUrl;
        } else {
          this.errorMessage = '未获取到有效的支付链接';
        }
      } catch (error) {
        this.errorMessage = '创建订单失败: ' + error.message;
      } finally {
        // 无论请求成功或失败，都恢复可点击状态
        this.isSubmitting = false;
      }
    }
  }
};
</script>

<style scoped>
.amount-input-container {
  text-align: center;
  padding: 20px;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0px 3px 6px 0px #232B321A;
  margin: 20px auto;
  width: calc(100% - 40px);
}
.input-group {
  margin-bottom: 15px;
}
.input-group label {
  display: block;
  margin-bottom: 5px;
  color: #333;
  font-weight: 600;
  font-size: 1.2rem;
}
.input-group input,
.input-group select { 
  width: 100%;
  padding: 10px;
  box-sizing: border-box;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 0.8rem;
}
.submit-button {
  background: #3F9FFF;
  color: #fff;
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 600;
  font-size: 0.8rem;
}
.submit-button:hover {
  background: #2e86d9;
}
/* 新增错误提示样式 */
.error-message {
  color: red;
  margin-bottom: 10px;
}
.name-note {
  font-size: 0.8rem;
  color: #ff6666;
  text-align: left;
  margin-top: 5px;
}
</style>